import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { useNavigate } from 'react-router-dom';
import { useModalExtra, useHideExtraModal } from './ModalHooks';
import LogoBabastudio from '../../asset/Logo_Babastudio.png';
import LogoTechfor from '../../asset/Logo_Techfor.png';
import LogoSekolahpintar from '../../asset/Logo_SekolahPintar.png';
import {api} from '../../redux/config';
import { Grid, Paper, Button, ListItem, ListItemText } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import SchoolIcon from '@material-ui/icons/School';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HomeIcon from '@material-ui/icons/Home';
import TimerIcon from '@material-ui/icons/Timer';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import NumberFormat from 'react-number-format';
import Avatar from '@material-ui/core/Avatar';
import TikTok from '../../asset/tik-tok-logo.png';
import Youtube from '../../asset/youtube-icon.png';
import LinkedIn from '../../asset/linkedin-icon.png';
import Facebook from '../../asset/facebook-icon.png';
import Instagram from '../../asset/instagram-logo.jpg';
import Certificate from '../../asset/Certificate.jpg';
import CertificateNew from '../../asset/CertificateNew.jpeg';
import { useDispatch } from 'react-redux';
import { showModalAction } from '../../redux/action/modalAction';

const loggedInUserBabaPrakerja = JSON.parse(localStorage.getItem('loggedInUserBabaPrakerja'))

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  hover: {
    cursor: 'pointer'
  },
  img: {
    [theme.breakpoints.down('xs')]: {
      width: '140px'
    },
    maxWidth: '250px',
    maxHeight: '56px',
  },
  title: {
    marginLeft: theme.spacing(2),
  },
  desktop: {
    [theme.breakpoints.up('md')]: {
      display: 'block'
    },
    display: 'none'
  },
  next: {
    [theme.breakpoints.up('md')]: {
      top: '7%',
      left: '60%',
      position: 'fixed',
    },
  },
  paper:{
    [theme.breakpoints.up('md')]: {
      padding: 16,
      paddingInline: 40
    }
  },
  summary:{
    display: 'flex',
    alignItems: 'center',
    paddingBlock: 8
  },
  icon:{
    marginInline: 10
  },
  small: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    margin: 8,
    cursor: 'pointer'
  },
  btn:{
    [theme.breakpoints.down('sm')]: {
      bottom: '6%',
      // alignItems:'center',
      left: '10%',
      width:'65%',
      position: 'fixed',
    },
    [theme.breakpoints.down('xs')]: {
      bottom: '5%',
      // alignItems:'center',
      left: '7%',
      width:'60%',
      position: 'fixed',
    },
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiAccordionDetails);

const FullScreenDialog = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [expanded, setExpanded] = React.useState("panel0");
  const [detailCourse, setDetailCourse] = React.useState(false);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const modal = useModalExtra().modalExtra.payload.extraModalReducer;
  const { handleOnCloseExtra } = useHideExtraModal();

  const handleNavigate = (path) => {
    handleOnCloseExtra();
    navigate(path)
  };

  const getDynamicImage = () => {
    if(process.env.REACT_APP_PLATFORM === "Babastudio"){
        return LogoBabastudio
    } else if (process.env.REACT_APP_PLATFORM === "SekolahPintar") {
        return LogoSekolahpintar
    } else if (process.env.REACT_APP_PLATFORM === "Techfor.id") {
        return LogoTechfor
    } else {
        return null
    }
  };

  const dispatch = useDispatch();


  React.useEffect(() => {
    if(modal.id){
      api.get(`/mycourse/get-silabus?course_id=${modal.id}`)
      .then(res => {
        setDetailCourse(res.data.data)
      })
      .catch(err => {
        console.log(err)
      })
    }
    if(modal.is_active_notif === 1){
      dispatch(showModalAction({
        title: 'Notifikasi',
        body: `Nama lain dari kursus ini adalah : ${modal.title_en}`
      }));
    }
  }, [modal.id])

  const ButtonClose = ({full}) => {
    return (
      <Button color='primary' variant='contained' fullWidth={full} onClick={handleOnCloseExtra}>Tutup soal</Button>
    )
  }

  return (
    <div>
      <Dialog fullScreen open={modal.showExtra && !modal.fullscreen} onClose={handleOnCloseExtra} TransitionComponent={Transition}>
        <AppBar className={classes.appBar} color="white">
          <Toolbar>
            <img onClick={() => window.location.assign('/')} className={clsx(classes.hover, classes.img)} src={getDynamicImage()} width={250} alt={process.env.REACT_APP_MAIN_URL}/>
            <div style={{flex: 1}} />
            {modal.body ? <ButtonClose /> :
            <IconButton edge="end" color="inherit" onClick={handleOnCloseExtra} aria-label="close">
              <CloseIcon />
            </IconButton> }
          </Toolbar>
        </AppBar>
        {modal.body ? 
        <>
          {modal.body}
          <div style={{margin: 10}}>
            <ButtonClose full={true}/>
          </div>
        </> : 
        <div style={{display: 'grid', justifyItems: 'center'}}>
          <Grid container direction="row" justify="center">
            <Grid item sm={12} md={7}>
              <div style={{padding: 16}}>
                {modal.image ?
                  <div>
                    <img src={modal.image} style={{width: '100%', paddingTop: 8, paddingBottom: 8}} alt="Banner" onError={(e) => {e.target.onerror = null; e.target.src="https://miro.medium.com/max/3202/1*L5IJM6n8N4wiwqRgoZrWaw.png"}} /> 
                  </div> : null
                }
                {detailCourse && detailCourse.map((detail,i) => {
                  return(
                    <React.Fragment>
                      <Typography variant="h5">
                        <b>{detail.name}</b>
                      </Typography>
                      <Divider />
                      <Typography variant="h6">
                        <div dangerouslySetInnerHTML={{ __html: detail.description}}/>
                      </Typography>
                    </React.Fragment>
                    )
                  })
                }
                <Typography variant="h5">
                 <b>Contoh Desain Sertifikat</b> 
                </Typography>
                <Divider />
                {(modal.certificate === "" || modal.certificate === null) ? 
                <img src={modal.isNewCourse === 1 ? CertificateNew : Certificate} style={{width: '100%', paddingTop: 8}} alt="Sertifikat" /> :
                <img src={modal.certificate} style={{width: '100%', paddingTop: 8}} alt="Sertifikat" /> 
                }
                <Typography variant="h5" style={{paddingTop: 16}}>
                  <b>Kurikulum Kelas</b>
                </Typography>
                {modal.course_data && modal.course_data.map((detail,i) => {
                  return (
                    <Accordion
                      square
                      expanded={expanded === `panel${i}`}
                      onChange={handleChange(`panel${i}`)}
                    >
                      <AccordionSummary
                        aria-controls="panel3d-content"
                        id="panel3d-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <Typography>{detail.title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails style={{display: 'block'}}>
                        <Divider />
                        {detail.materials.map(materials => {
                          return (
                            <React.Fragment>
                              <ListItem>
                                {/* <CheckCircleIcon style={fullData.videoPerformance.includes(item.id) ? {color: green[500]} : {color: grey[500]}}/> */}
                                <SchoolIcon style={{paddingRight: 8}}/>
                                <ListItemText primary={materials.title} />
                                <ListItemText><div style={{alignItems: 'center', display: 'flex', float: 'right'}}><TimerIcon className={classes.icon}/> {materials.duration}</div></ListItemText>
                              </ListItem>
                              <Divider />
                            </React.Fragment>
                          )
                        })}
                      </AccordionDetails>
                    </Accordion>
                  )
                })}
              </div>
            </Grid>
            <Grid item sm={12} md={5}>
              <div className={classes.next}>
              <Paper elevation={1} className={classes.paper}>
                {/* <Typography variant="h6" className={classes.summary} gutterBottom>
                  <TimerIcon className={classes.icon} /> {modal.duration}
                </Typography> */}
                {/* <Typography variant="h6" className={classes.summary} gutterBottom>
                  <QueryBuilderIcon className={classes.icon} /> {modal.sisaHariBelajar} Hari Tersisa
                </Typography> */}
                {/* <Typography variant="h6" className={classes.summary} gutterBottom>
                  <VideoLibraryIcon className={classes.icon} /> {modal.total_video} Jumlah Video
                </Typography>
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <VideoLibraryIcon className={classes.icon} /> {modal.viewed_video === null ? 0 : modal.viewed_video} Video Selesai
                </Typography> */}
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <VideoLibraryIcon className={classes.icon} /> {modal.total_encounter === null ? 0 : modal.total_encounter} Pertemuan
                </Typography>
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <VideoLibraryIcon className={classes.icon} /> {modal.joined_encounter === null ? 0 : modal.joined_encounter} Pertemuan Selesai
                </Typography>
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <AssignmentIcon className={classes.icon} /> {modal.total_quiz} Total Quiz
                </Typography>
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <AssignmentIcon className={classes.icon} /> {modal.total_quiz_selesai} Quiz Selesai
                </Typography>
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <HomeIcon className={classes.icon} /> Platform : {modal.platform}
                </Typography>
                <Typography variant="h6" className={classes.summary} gutterBottom>
                  <AttachMoneyIcon className={classes.icon} /> <NumberFormat value={modal.price} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                </Typography>
                <Button fullWidth href={modal.daftar ? '/register' : modal.route} size="small" color="primary" variant="contained" className={classes.btn}>
                  {modal.daftar ? 'Daftar Kursus' : 'Mulai Belajar'}
                </Button>
                <div style={{display: 'flex', paddingBlock: 8}}>
                  {modal.linkTikTok && <Avatar alt="Tik-Tok" src={TikTok} className={classes.small} onClick={() => window.location.assign(modal.linkTikTok)} />}
                  {modal.linkYoutube && <Avatar alt="Youtube" src={Youtube} className={classes.small} onClick={() => window.location.assign(modal.linkYoutube)} />}
                  {modal.linkLinkein && <Avatar alt="LinkedIn" src={LinkedIn} className={classes.small} onClick={() => window.location.assign(modal.linkLinkein)} />}
                  {modal.linkFacebook && <Avatar alt="Facebook" src={Facebook} className={classes.small} onClick={() => window.location.assign(modal.linkFacebook)} />}
                  {modal.linkInstagram && <Avatar alt="Instagram" src={Instagram} className={classes.small} onClick={() => window.location.assign(modal.linkInstagram)} />}
                </div>
              </Paper>
              </div>
            </Grid>
          </Grid>
        </div>
      }
      </Dialog>
    </div>
  );
}

export default FullScreenDialog;